module.exports = __webpack_public_path__ + "static/media/ghetia.4104d909.jpg";